import util from 'preact-util';

// Build the URL StlViewer should fetch() for a model. The stored `s3Link` points
// at the /original CloudFront/S3 host, which sends NO Access-Control-Allow-Origin,
// so a cross-origin fetch() of it is blocked (unlike <img>, which needs no CORS).
// Route it instead through the app's own /api path on util.getApiServer() — the
// same server variable the working API calls use, and /api DOES send CORS headers.
// `entityPlural` is the route base ('products' | 'articles').
export function stlModelUrl(entityPlural, id, md5) {
    if (!entityPlural || !id || !md5) {
        return '';
    }
    const apiServer = util.getApiServer() || '';
    return `${apiServer}/api/${entityPlural}/public/${id}/model/${md5}`;
}

export function modelsNeedingSnapshot(models = [], images = []) {
    const list = Array.isArray(models) ? models : [];
    const imgs = Array.isArray(images) ? images : [];
    const covered = new Set(
        imgs.map(img => (img ? img.sourceModelMd5 : null)).filter(Boolean),
    );
    return list.filter(m => m && m.md5 && !covered.has(m.md5));
}

export function hasStlModel(product) {
    return !!(product && Array.isArray(product.models) && product.models.length > 0);
}
